import { render } from "./OrganizationApi.vue?vue&type=template&id=ee5a6ffa"
import script from "./OrganizationApi.vue?vue&type=script&lang=js"
export * from "./OrganizationApi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__